'use strict'

import axios from 'axios'

const defaultOptions = {
  timeout: 3000,
  crossDomain: true,
  withCredentials: false,
  debug: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: -1,
  }
}

const HttpExecutorFactory = () => {
  return {
    create: options => {
      let mergedOptions = _.merge(defaultOptions, options)
      const http = axios.create(mergedOptions)
      http.defaults.timeout = 50000;      // 50초...

      if (mergedOptions.debug === true) {
        http.interceptors.request.use(config => {
          console.log(
            `[HTTP] Request was called...
            - url : %s,`,
            config.url
          )
          return config
        })
        http.interceptors.response.use(response => {
          console.log(response.data)
          console.log(
            `[HTTP] Response was recevied...
             - status : %s,
             - data: %o,
             - uri: %s`,
            response.status,
            response.data,
            response.request.responseURL
          )

          return response
        })
      }
      return http
    }
  }
}

export default HttpExecutorFactory()


// WEBPACK FOOTER //
// ./src/modules/general/http.js